// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dashboardtablehead{
  font-weight: bold;
}

.search{
  width: 50px;
}

.jenis-pegawai{
  padding-left: 0px;
  margin-left: 0px;
}


.label-jenis{
  margin-left: 0px;
}

.Scroll{
  height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}


.download-table-xls-button {
  background-color: red;
  margin-left: 50px;
  margin-bottom: 30px;
  border-radius: 10px;
  width: 150px;
  height: 35px;
}

.search {
  margin-left: 5px;
  margin-bottom: 30px;
  border-radius: 5px;
  width: 300px;
  height: 35px;
}

.button is-primary mb-2 {
  margin-top: 10px;
}

.table__wrapper {
  display: block;
  max-width: -moz-fit-content;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
  margin-left: 10px;
  margin-right: 10px;
  overflow: auto;
}

.table__wrapper_Scroll_Log{
  display: block;
  max-width: -moz-fit-content;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
  margin-left: 10px;
  margin-right: 10px;
  height: 600px;
  overflow: auto;
}

.label-unit {
  margin-left: 50px;
}

.all{
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 50px;
}

th.has-text-centered {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/component/UserRole/userList.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\n.dashboardtablehead{\n  font-weight: bold;\n}\n\n.search{\n  width: 50px;\n}\n\n.jenis-pegawai{\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n\n.label-jenis{\n  margin-left: 0px;\n}\n\n.Scroll{\n  height: 100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n\n.download-table-xls-button {\n  background-color: red;\n  margin-left: 50px;\n  margin-bottom: 30px;\n  border-radius: 10px;\n  width: 150px;\n  height: 35px;\n}\n\n.search {\n  margin-left: 5px;\n  margin-bottom: 30px;\n  border-radius: 5px;\n  width: 300px;\n  height: 35px;\n}\n\n.button is-primary mb-2 {\n  margin-top: 10px;\n}\n\n.table__wrapper {\n  display: block;\n  max-width: -moz-fit-content;\n  margin: 0 auto;\n  overflow-x: auto;\n  white-space: nowrap;\n  margin-left: 10px;\n  margin-right: 10px;\n  overflow: auto;\n}\n\n.table__wrapper_Scroll_Log{\n  display: block;\n  max-width: -moz-fit-content;\n  margin: 0 auto;\n  overflow-x: auto;\n  white-space: nowrap;\n  margin-left: 10px;\n  margin-right: 10px;\n  height: 600px;\n  overflow: auto;\n}\n\n.label-unit {\n  margin-left: 50px;\n}\n\n.all{\n  margin-left: 50px;\n  margin-right: 50px;\n  margin-top: 50px;\n}\n\nth.has-text-centered {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
